import { useEffect, useState } from "react";
import Project from "../models/Project";


const useProject = ({ projectId }) => {
  const [project, setProject] = useState(null);

  useEffect(() => {
    async function run() {
      const proj = await Project.get(projectId);

      setProject(proj);
    }

    run();
  }, []);

  return project;
};

export default useProject;
